import { render, staticRenderFns } from "./ActionConfirmationDialog.vue?vue&type=template&id=b4a26870"
import script from "./ActionConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ActionConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports